module.exports = __webpack_public_path__ + "static/media/mosprom.ac43c436.svg";